import parallel from 'async/parallel'
riot.tag2('add-fields-edit-modal', '  <bs-modal>\n    <yield to="title">\n      <div class="h4 modal-title">Карточка элемента</div>\n    </yield>\n    <yield to="body">\n      <loader if="{loader}"></loader>\n      <form if="{!loader}" onchange="{change}" onkeyup="{change}">\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Наименование</label>\n          <input class="form-control" name="name" value="{item.name}">\n          <div class="help-block">{error.name}</div>\n        </div>\n        <div class="form-group {has-error: error.name}">\n          <label class="control-label">Код</label>\n          <input class="form-control" name="code" value="{item.code}">\n          <div class="help-block">{error.name}</div>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Группа</label>\n          <select class="form-control" name="idGroup" value="{item.idGroup}">\n            <option value="">Без группы</option>\n            <option each="{group in groups}" __selected="{item.idGroup == group.id}" value="{group.id}">{group.name}</option>\n          </select>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Тип элемента</label>\n          <select class="form-control" name="type" value="{item.type}">\n            <option value="string">Строка</option>\n            <option value="number">Число</option>\n            <option value="text">Текст</option>\n            <option value="select">Список</option>\n            <option value="checkbox">Флажок</option>\n            <option value="radio">Переключатель</option>\n            <option value="date">Дата</option>\n          </select>\n        </div>\n        <div class="form-group">\n          <label class="control-label">Подсказка</label>\n          <input class="form-control" name="placeholder" value="{item.placeholder}">\n        </div>\n        <div class="form-group" if="{~[&quot;select&quot;, &quot;checkbox&quot;, &quot;radio&quot;].indexOf(item.type)}">\n          <label class="control-label">Значения</label>\n          <input class="form-control" name="values" value="{item.values}" placeholder="Возможные значения (через запятую)">\n        </div>\n        <div class="form-group">\n          <label class="control-label">Описание</label>\n          <textarea class="form-control" name="description" value="{item.description}" style="resize: none;"></textarea>\n        </div>\n        <div class="form-group">\n          <div class="checkbox-inline">\n            <label>\n              <input name="enabled" type="checkbox" __checked="{parseInt(item.enabled)}" data-bool="1,0">Активный\n            </label>\n          </div>\n          <div class="checkbox-inline">\n            <label>\n              <input name="required" type="checkbox" __checked="{parseInt(item.required)}" data-bool="1,0">Обязательный\n            </label>\n          </div>\n        </div>\n      </form>\n    </yield>\n    <yield to="footer">\n      <button class="btn btn-default btn-embossed" onclick="{modalHide}" type="button">Закрыть</button>\n      <button class="btn btn-primary btn-embossed" onclick="{parent.opts.submit.bind(this)}" type="button">Сохранить</button>\n    </yield>\n  </bs-modal>\n', '', '', function(opts) {
'use strict';

var self = this;

self.on('mount', function () {
    var modal = self.tags['bs-modal'];

    var filters = [];

    if (opts.data) filters.push({
        field: 'data',
        value: opts.data
    });

    modal.mixin('validation');
    modal.mixin('change');

    modal.item = {
        idGroup: '',
        type: 'string',
        enabled: 1
    };

    modal.rules = {
        name: 'empty',
        code: 'empty'
    };

    modal.afterChange = function (e) {
        modal.error = modal.validation.validate(modal.item, modal.rules, e.target.name);
    };

    modal.loader = true;

    if (opts.id) {
        parallel([function (callback) {
            API.request({
                object: 'CustomField',
                method: 'Info',
                data: { id: opts.id },
                success: function success(response) {
                    modal.item = response;
                    callback(null, 'AddFieldOrder');
                },
                error: function error() {
                    callback('error', null);
                }
            });
        }, function (callback) {
            API.request({
                object: 'CustomFieldGroup',
                method: 'Fetch',
                data: { filters: filters },
                success: function success(response) {
                    modal.groups = response.items;
                    callback(null, 'AddFieldOrderGroup');
                },
                error: function error() {
                    callback('error', null);
                }
            });
        }], function (err, res) {
            modal.loader = false;
            modal.update();
        });
    } else {
        API.request({
            object: 'CustomFieldGroup',
            method: 'Fetch',
            data: { filters: filters },
            success: function success(response) {
                modal.groups = response.items;
                modal.loader = false;
                modal.update();
            }
        });
    }
});
});


// WEBPACK FOOTER //
// ./pages/settings/add-fields/add-fields-edit-modal.tag